// extracted by mini-css-extract-plugin
module.exports = {"main":"App_main_2xcRE","hasStatus":"App_hasStatus_1j084","content":"App_content_pIJBB","isNative":"App_isNative_1XxHM"};